import FieldProto from "../../../../fields3/proto/field-proto"
import FieldConfig from "../../../../fields3/proto/field-config"
import FieldProjectType_Editable from "./render/editable/editable"
import {ProjectSystemTypeName} from "../../../../model2/project/types"
import FieldProjectType_TableCell from "./render/table/table-cell";

export default class FieldProjectType extends FieldProto {

    constructor(config:FieldConfig) {
        super(config)

        this.typeLabel = "Project System Type"

        this.renderComponents.editable  = FieldProjectType_Editable
        this.renderComponents.tableCell = FieldProjectType_TableCell
    }

    getViewValue(model:any) {
        let res

        const template = gd.session.templatesList.get(model.localTemplateId)
        if (template) {
            res = template.name
        } else {
            // @ts-ignore
            res = ProjectSystemTypeName[model.systemType]
        }

        return res
    }
}
